<template>
  <div
    :class="[
      'ss__input__wrapper',
      {'ss__input__wrapper--focus': inputIn}
    ]">
    <div v-if="$slots.message" class="ss__input__message">
      <slot name="message"></slot>
    </div>
    <div v-if="$slots.prepend" class="ss__input__prepend">
      <slot name="prepend"></slot>
    </div>
    <template v-if="$slots.input">
      <slot name="input"></slot>
    </template>
    <input
      v-else
      ref="input"
      class="ss__input"
      :placeholder="placeholder"
      :type="type"
      :value="value_"
      :disabled="disabled"
      @input="onInput"
      @change="onChange"
      @focus="onFocus"
      @blur="onBlur"
      @keyup.enter="onEnter"
    />
    <div v-if="$slots.append" class="ss__input__append">
      <slot name="append"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SsInput',

  model: {
    prop: 'value',
    event: 'input'
  },

  props: {
    value: {
      type: [String, Number],
      required: true
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      value_: '',
      inputIn: false
    }
  },

  watch: {
    value: {
      immediate: true,
      handler: function () {
        this.value_ = this.value
      }
    }
  },

  methods: {
    focus () {
      this.$refs.input.focus()
    },
    blur () {
      this.$refs.input.blur()
    },
    onFocus () {
      this.inputIn = true
      this.$emit('focus')
    },
    onBlur () {
      this.inputIn = false
      this.$emit('blur')
    },
    onInput (e) {
      this.$emit('input', e.target.value)
    },
    onChange (e) {
      this.$emit('change', e.target.value)
    },
    onEnter (e) {
      this.$emit('enter', e.target.value)
      this.blur()
    }
  }
}
</script>

<style lang="stylus" scoped>
.ss__input__wrapper {
  position: relative;
  display: flex
  justify-content: space-between
  background: var(--color-bg-ssInput, var(--B0-t))
  outline: var(--outline-ssInput, (2px solid var(--B2-t)))!important
  border-radius: var(--radius-ssInput, 12px)
  padding: var(--inset-ssInput, (12px 12px 12px 16px))
  color: var(--color-ssInput-default, var(--B6-t))
  font-size: var(--text-ssInput, 15px)
  line-height: var(--leading-ssInput, 21px)
  transition: .2s
  &.ss__input__wrapper--focus {
    outline: var(--outline-ssInput, (2px solid var(--B4-t)))!important
  }
  .ss__input {
    flex: 1
    border: none
    background: transparent
    padding: 5.5px 0px
    font-size: inherit
    line-height: inherit
    color: var(--color-ssInput-active, var(--B8-t))
    &::placeholder {
      color: var(--color-ssInputPlaceholder, var(--B6-t))
    }
  }
  .ss__input__prepend {
    display: inline-flex
    align-items: center
    position relative
    padding-right: 8px
    margin-right: 16px
    & > span {
      max-width: 4em
      padding: 5.5px 0px
    }
    &::after {
      content: ''
      display: block
      position: absolute
      width: 1px
      background: var(--B3-t)
      top: 8px
      bottom: 8px
      right: 0px
    }
  }
  .ss__input__append {
  }
  .ss__input__message {
    position: absolute;
    z-index: 0;
    width: 100%;
    height: 100%;
    padding: 12px 16px;
    box-sizing: border-box;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    color: var(--red-t);
    font-size: 15px;
    font-weight: 500;
  }
}
</style>
